/**
 * List-shell-shaped loading placeholder — avoids bare "Loading…" text flash (§1E).
 */

export function PlanningListSkeleton({ className = 'h-full min-h-[320px]' }: { className?: string }) {
  return (
    <div
      className={` border border-[var(--rule)]/80 dark:border-[var(--rule)] bg-[var(--bg-raised)] dark:bg-[var(--surface)] shadow-sm overflow-hidden animate-pulse ${className}`}
      aria-busy="true"
      aria-label="Loading"
    >
      <div className="px-6 py-3 border-b border-[var(--rule)] dark:border-[var(--rule)] flex items-center gap-3">
        <div className="h-8 w-8 bg-[var(--hover-tint)] dark:bg-[var(--hover-tint)] shrink-0" />
        <div className="flex-1 space-y-2">
          <div className="h-4 w-36 bg-[var(--hover-tint)] dark:bg-[var(--hover-tint)] rounded" />
          <div className="h-3 w-56 bg-[var(--surface)] dark:bg-[var(--bg)] rounded" />
        </div>
        <div className="h-8 w-48 bg-[var(--surface)] dark:bg-[var(--bg)]" />
      </div>
      <div className="px-4 py-2 border-b border-[var(--rule)] dark:border-[var(--rule)] flex gap-2">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="h-7 w-14 bg-[var(--surface)] dark:bg-[var(--bg)] rounded" />
        ))}
      </div>
      <div className="p-4 space-y-2">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="h-11 bg-[var(--surface)] dark:bg-[var(--bg)]" />
        ))}
      </div>
    </div>
  );
}
